import {
  HORIZONTAL_ASPECTS_STRING,
  SQUARE_ASPECTS_STRING
} from '@anm/data/aspects';

import { TemplatePage } from './types';

const useCasesPage: TemplatePage = {
  header: {
    color: '#DDDFDE',
    icon: 'images/video-templates/use-cases.jpg',
    title: 'Video Templates for Various Use Cases',
    title_meta: '500+ Editable Video Templates for Various Use Cases',
    description_meta:
      'Create captivating video content in a matter of minutes with Wave.video’s collections of pre-made video ' +
      'templates for various use cases and business purposes.',
    description:
      'Create captivating video content in a matter of minutes with Wave.video’s collections of pre-made video ' +
      'templates for various use cases and business purposes. Customizable and free!'
  },
  footer: {
    category: 'Use Cases',
    description:
      'With Wave.video’s diverse collections of editable video templates for various use cases, you will save time ' +
      'and effort when making engaging video content for your niche. All you need to do is choose a video template ' +
      'that suits your goals best, customize it to your branding, and download or share directly on social media.'
  },
  content: [
    {
      type: 'slider',
      title: 'Trailers',
      name: 'use-cases-trailers',
      search: {
        category: '/Use Cases/Trailers',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Blog promotion',
      name: 'use-cases-blog-promotion',
      search: {
        category: '/Use Cases/Blog Promotion',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Countdown',
      name: 'use-cases-countdown',
      search: {
        name: 'countdown',
        tags: 'countdown',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Event promotion',
      name: 'use-cases-event-promotion',
      search: {
        category: '/Use Cases/Event Promotion',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Zoom Video Backgrounds',
      name: 'use-cases-zoom-backgrounds',
      search: {
        category: '/Use Cases/Virtual Backgrounds',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Fun social posts',
      name: 'use-cases-fun-social-posts',
      search: {
        category: '/Use Cases/Entertainment',
        aspects: SQUARE_ASPECTS_STRING
      }
    },

    {
      type: 'slider',
      title: 'Happy birthday',
      name: 'holidays-birthday',
      search: {
        name: 'birthday',
        tags: 'birthday',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Listicles',
      name: 'use-cases-listicles',
      search: {
        category: '/Use Cases/Listicles',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Lower third',
      name: 'use-cases-lower-third',
      search: {
        name: 'lower third',
        tags: 'lower third',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Podcast promotion',
      name: 'use-cases-podcast-promotion',
      search: {
        category: '/Use Cases/Podcast Promotion',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'product demo',
      name: 'use-cases-slideshow',
      search: {
        category: '/Use Cases/Product Demo',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Special offers and sales',
      name: 'use-cases-special-offers',
      search: {
        category: '/Use Cases/Special Offers & Sales',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Travel vlog',
      name: 'use-cases-travel-vlog',
      search: {
        name: 'travel vlog',
        tags: 'vlog, blog',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Tutorials',
      name: 'use-cases-tutorials',
      search: {
        category: "/Use Cases/How To's & Tutorials",
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Greeting',
      name: 'use-cases-greeting',
      search: {
        category: '/Use Cases/Greetings',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Video games',
      name: 'industry-video-game',
      search: {
        name: 'game',
        tags:
          'video game, video games, xbox, nintendo, gameboy, video game day, playstation, gaming, console',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'stocks',
      title: 'use cases',
      search: { name: 'use cases' }
    },
    {
      type: 'calendar'
    }
  ]
} as TemplatePage;

export default useCasesPage;
